<template>
    <div class="wrapper timePickerWrapper">
      <vue-timepicker v-model="theDate" format="HH:mm" :minute-interval="15"></vue-timepicker>
    </div>
</template>
<script>
import { abstractField } from 'vue-form-generator'
import VueTimepicker from 'vuejs-timepicker'
import { isNil } from 'lodash'
export default {
  beforeMount () {
    if (isNil(this.value)) {
      this.value = ''
    }
  },
  components: {
    VueTimepicker
  },
  mixins: [abstractField],
  computed: {
    theDate: {
      get: function () {
        if (this.value !== '' && this.value !== null) {
          var splitTime = this.value.split(':')
          if (splitTime[0] !== '' && splitTime[0].length < 2) {
            splitTime[0] = '0' + splitTime[0]
          }
          return {HH: splitTime[0], mm: splitTime[1]}
        }
        return {HH: null, mm: null}
      },
      set: function (newValue) {
        this.value = newValue.HH + ':' + newValue.mm
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/vfg-custom-fields/fieldTimePickerEndTime.vue